module.exports = "<style>:host {\n    box-shadow: 1px 1px 1px #ccc, -1px -1px 1px #ddd;\n    border-radius: 5px;\n    padding: 15px;\n    overflow: auto;\n    display: inline-block;\n    font-family: Helvetica, Arial, Verdana;\n    text-align: center;\n}\n\nimg {\n    height: 72px;\n    width: 72px;\n    margin: 24px;\n}\n\n.text {\n    margin: 0 10px 24px 10px;\n}\n\nbutton {\n    float: right;\n    padding: 15px;\n    font-size: 14px;\n}\n</style>\n<div>\n    <img src=\"./assets/car.svg\" />\n    <div class=\"text\">[[message]]</div>\n    <button on-click=\"showAlert\">Alert me!</button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/demo-component.html
// module id = 17
// module chunks = 0